import { Component, OnInit, Renderer2 } from '@angular/core';
import { ModalConfig } from '../controls/modal/modal-config';
import { ModalRef } from '../controls/modal/modal-ref';
import { Tab, TabColor } from '../controls/tabs/tabs.component';

export enum AboutPageTab {
  ABOUT,
  CONTACT
}

@Component({
    selector: 'app-about-box',
    templateUrl: './about-box.component.html',
    styleUrls: ['./about-box.component.css'],
    standalone: false
})
export class AboutBoxComponent implements OnInit {

  AboutPageTab = AboutPageTab;
  TabColor = TabColor;
  activeTab: AboutPageTab = AboutPageTab.ABOUT;
  aboutTab = new Tab('otsc-about-dialog_about_tab', $localize`About`, undefined, false);
  contactTab = new Tab('otsc-about-dialog_contact_info_tab', $localize`Contact Information`, undefined, false);
  tabs: Tab[] = [this.aboutTab, this.contactTab];
  productVersion: string = "";


  constructor(private renderer: Renderer2, private modalRef: ModalRef, private modalConfig: ModalConfig) { 
    this.productVersion = this.modalConfig.data.productVersion;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.renderer.selectRootElement('#otsc-about-dialog_close_btn', true).focus();
    }, 0);
  }

  close():void {
    this.modalRef.close();
  }

  onSelectedTabChange(selectedIndex: number) {
    this.activeTab = selectedIndex;
  }

  onKey(event: KeyboardEvent):void {
    if(event.key === "Escape"){
      this.close();
    }
  }
}
